import Vue from "vue";
import { Dialog } from 'element-ui'
import router from '@/router'
const body = document.body;
function BaseDialog({ component, props={}, options={}, cbs={}, on={}, slots ={} }) {
  let instance = new Vue({
    router,
    components: {
      Dialog
    },
    data: {
      visible: true,
    },
    render(h) {
      return h("Dialog", {
        props: {
          ...options,
          visible: this.visible
        },
        on: {
          'close': this.onClose,
          ...on
        },
        scopedSlots: {
          default: ()=> h(component, {
            props: {
              ...props,
              cbs
            },
            ref: 'componentVm',
            on: {
              close: this.onClose
            }
          }),
          ...Object.keys(slots).reduce((pre, item)=> {
            pre[item] = slots[item].bind(null, h)
            return pre
          }, {})
        }
      })
    },
    methods: {
      handleVisible() {
        setTimeout(() => {
            if (!instance) {
              return;
            }
            this.$destroy()
            const el = this.$el;
            el && body.removeChild(el);
            instance = null;
      }, 360)
      },
      onClose() {
        this.visible = false;
        window.removeEventListener('popstate', popStateHandle); // 移除popstate事件监听器
        this.handleVisible()
      },
      // 外部方便调用
      close() {
        this.onClose()
      }
    }
  });

  const vm = instance.$mount();
  this.vm = vm;
  this.cVm = vm.$refs.componentVm;
  body.appendChild(vm.$el);
  const popStateHandle = () => {
    vm.close();
  }
  window.addEventListener('popstate', popStateHandle);
};
export default BaseDialog;